export const random = () => {
  const char = "abcdefghijklmnopqrstuvwxyz123456789"
  let id = "";
  for(let i=0; i<10; i++){
  	id += char[Math.floor(Math.random()*35)];
  }
  return id
}
